<main class="tracking-main">

  <!-- ─── SEARCH VIEW ─── -->
  <section class="search-section" *ngIf="!hasCode">
    <div class="search-content">

      <div class="search-heading">
        <div class="search-heading-icon"><i class="fas fa-search-location"></i></div>
        <div>
          <h1 class="search-title">{{ 'TRACKING.TITLE' | translate }}</h1>
          <p class="search-subtitle">{{ 'TRACKING.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <form class="search-card" (ngSubmit)="redirectToTracking()">
        <label class="search-label" for="trackingCode">
          {{ 'TRACKING.INPUT.LABEL' | translate }}
        </label>
        <div class="search-input-row">
          <div class="search-input-wrapper" [class.is-invalid]="hasError()">
            <i class="fas fa-barcode search-input-icon"></i>
            <input
              id="trackingCode"
              type="text"
              name="trackingCode"
              class="search-input"
              [placeholder]="'TRACKING.INPUT.PLACEHOLDER' | translate"
              [(ngModel)]="trackingCode"
              (keypress)="allowOnlyAlphanumeric($event)"
              (keyup.enter)="redirectToTracking()"
              autocomplete="off"
            />
          </div>
          <button
            type="submit"
            class="search-btn"
            [disabled]="!trackingCode || trackingCode.trim().length === 0 || isLoading"
          >
            <ng-container *ngIf="!isLoading">
              {{ 'TRACKING.INPUT.BUTTON' | translate }}
              <i class="fas fa-arrow-right"></i>
            </ng-container>
            <ng-container *ngIf="isLoading">
              <i class="fa-solid fa-magnifying-glass search-animation"></i>
            </ng-container>
          </button>
        </div>
        <div *ngIf="hasError()" class="search-error">
          <i class="fas fa-exclamation-circle"></i>
          {{ getErrorMessage() | translate }}
        </div>
      </form>

      <p class="search-hint">
        <i class="fas fa-info-circle"></i>
        Il numero di spedizione è disponibile sulla documentazione di consegna o nella tua email di conferma.
      </p>

    </div>
  </section>

  <!-- ─── LOADING VIEW ─── -->
  <section class="loading-section" *ngIf="hasCode && !notFound && !loadError">
    <div class="loading-icon-wrap">
      <i class="fas fa-truck"></i>
    </div>
    <h2 class="loading-title">{{ 'TRACKING.DETAILS.TITLE' | translate }}</h2>
    <p class="loading-code">#{{ trackingCode }}</p>
    <p class="loading-sub">{{ 'TRACKING.DETAILS.SUBTITLE' | translate: { trackingCode: trackingCode } }}</p>
  </section>

  <!-- ─── NOT FOUND VIEW ─── -->
  <section class="notfound-section" *ngIf="hasCode && notFound">
    <div class="notfound-icon-wrap">
      <i class="fas fa-box-open"></i>
    </div>
    <h2 class="notfound-title">{{ 'TRACKING.NOT_FOUND.TITLE' | translate }}</h2>
    <p class="notfound-code">#{{ trackingCode }}</p>
    <p class="notfound-sub">{{ 'TRACKING.NOT_FOUND.SUBTITLE' | translate }}</p>
    <button class="notfound-btn" (click)="resetSearch()">
      <i class="fas fa-arrow-left"></i>
      {{ 'TRACKING.NOT_FOUND.RETRY' | translate }}
    </button>
  </section>

  <!-- ─── ERROR VIEW ─── -->
  <section class="notfound-section" *ngIf="hasCode && loadError">
    <div class="notfound-icon-wrap notfound-icon-wrap--error">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h2 class="notfound-title">{{ 'TRACKING.ERROR.TITLE' | translate }}</h2>
    <p class="notfound-sub">{{ 'TRACKING.ERROR.SUBTITLE' | translate }}</p>
    <button class="notfound-btn" (click)="resetSearch()">
      <i class="fas fa-arrow-left"></i>
      {{ 'TRACKING.ERROR.RETRY' | translate }}
    </button>
  </section>

</main>
